import {
  faCalendarPlus,
  faCheckCircle,
  faClock,
  faIndianRupeeSign,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { useState } from 'react';
import { Badge, Button, Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import EditExamModal from '../../../../components/Modals/EditExamModal';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../../routes/routes';
import { ExamServices } from '../../../../Services/examServices';

interface IExamData {
  examData: any;
  reloadData: any;
}

const statusVariant = (status: string) =>
  status === 'live' ? 'success' : status === 'pending' ? 'warning' : 'secondary';

export default function Examcard({ examData, reloadData }: IExamData) {
  const navigate = useNavigate();

  const [showEditModal, setShowEditModal] = useState(false);
  const [examId, setExamId] = useState('');

  const formatDate = (date: any) => moment(date).format('DD-MM-YYYY HH:mm a');

  const handelDeleteClick = async (_id: string) => {
    await ExamServices.deleteOneExam(_id)
      .then((res) => {
        if (res.status === 200) {
          toast.success('Exam deleted successfully');
        }
        reloadData();
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  return (
    <>
      <Card className="xrg-card xrg-exam-card shadow-sm mb-3">
        <Card.Body>
          {/* Header */}
          <div className="d-flex flex-wrap justify-content-between align-items-start gap-3">
            <div className="flex-grow-1">
              <h6 className="fw-bold mb-2">{examData.examName}</h6>
              <div className="d-flex flex-wrap align-items-center gap-3">
                <span className="d-flex align-items-center gap-2 fs-12 text-muted">
                  User Show:
                  <FontAwesomeIcon
                    icon={examData.userShow ? faCheckCircle : faTimesCircle}
                    className={examData.userShow ? 'text-success' : 'text-danger'}
                  />
                </span>
                {examData?.status && (
                  <span className="d-flex align-items-center gap-2 fs-12 text-muted">
                    Status:
                    <Badge
                      bg={statusVariant(examData.status)}
                      className="text-capitalize"
                    >
                      {examData.status}
                    </Badge>
                  </span>
                )}
              </div>
            </div>

            {/* Actions */}
            <div className="d-flex flex-wrap gap-2">
              <Button
                size="sm"
                variant="outline-danger"
                onClick={() => handelDeleteClick(examData._id)}
              >
                Delete
              </Button>
              <Button
                size="sm"
                variant="light"
                onClick={() => {
                  setExamId(examData._id);
                  setShowEditModal(true);
                }}
              >
                Edit
              </Button>
              <Button
                size="sm"
                variant="outline-primary"
                onClick={() => navigate(baseUrl + '/exam/' + examData._id)}
              >
                View (Old)
              </Button>
              <Button
                size="sm"
                variant="primary"
                onClick={() =>
                  navigate(baseUrl + '/exam/' + examData._id + '/details')
                }
              >
                View
              </Button>
              <Button
                size="sm"
                variant="warning"
                onClick={() =>
                  navigate(baseUrl + '/exam/getExamQuestions/' + examData._id)
                }
              >
                Exam Questions
              </Button>
            </div>
          </div>

          <hr className="my-3" />

          {/* Details */}
          <Row className="g-3">
            <Col md={8}>
              <Row className="g-3">
                <Col sm={6}>
                  <div className="xrg-exam-meta-label">Subject</div>
                  <div className="fw-semibold">{examData.subject || '-'}</div>
                </Col>
                <Col sm={6}>
                  <div className="xrg-exam-meta-label">
                    <FontAwesomeIcon icon={faIndianRupeeSign} className="me-1" />
                    Fees
                  </div>
                  <div className="fw-semibold">₹ {examData?.fees ?? 'N/A'}</div>
                </Col>
                <Col sm={6}>
                  <div className="xrg-exam-meta-label">
                    <FontAwesomeIcon icon={faCalendarPlus} className="me-1" />
                    Created at
                  </div>
                  <div className="fw-semibold">{formatDate(examData.createdAt)}</div>
                </Col>
                <Col sm={6}>
                  <div className="xrg-exam-meta-label">
                    <FontAwesomeIcon icon={faClock} className="me-1" />
                    Last updated
                  </div>
                  <div className="fw-semibold">
                    {new Date(examData.updatedAt).toLocaleDateString()}
                  </div>
                </Col>
              </Row>
            </Col>
            <Col md={4}>
              {examData.tags?.length > 0 && (
                <>
                  <div className="xrg-exam-meta-label mb-1">Tags</div>
                  <div className="d-flex flex-wrap gap-2">
                    {examData.tags.map((tag: any, i: number) => (
                      <Badge key={i} bg="light" className="xrg-exam-tag">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </>
              )}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <EditExamModal
        setShow={setShowEditModal}
        examId={examId}
        show={showEditModal}
        reloadData={reloadData}
      />
    </>
  );
}
